module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// ../~/browserify-sign/algos.js
// module id = 329
// module chunks = 0